import { useEffect } from 'react';
import { useControl } from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import type { MapDetail } from '~/common/types';
import store from '../store';

export const PrintViewScale = () => {
  const { currentMap } = useSnapshot(store) as typeof store;

  const { setUnit } = useControl(
    ({ mapLib }) =>
      new mapLib.ScaleControl({
        // only accepts 2 properties: unit and maxWidth
        unit: (currentMap as MapDetail).unitSystem,
      }),
    { position: 'top-right' },
  );

  useEffect(() => {
    Array.from(document.getElementsByClassName('mapboxgl-ctrl mapboxgl-ctrl-scale'))[0].setAttribute(
      'style',
      'position: absolute; right: 0.5rem; top: 3.5rem; color: #6E7376; border-color: #6E7376; box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);',
    );

    document.querySelectorAll('.mapboxgl-ctrl-bottom-left, .mapboxgl-ctrl-bottom-right').forEach((element) => {
      element.setAttribute('style', 'z-index: auto;');
    });
  }, []);

  useEffect(() => {
    setUnit((currentMap as MapDetail).unitSystem);
  }, [(currentMap as MapDetail).unitSystem, setUnit]);

  return null;
};
